'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Dummy data for testing
var DUMMY = require('!json-loader!../../doc/dummyData/winresSchedule.json');

var ScheduleService = exports.ScheduleService = function () {
    function ScheduleService($q, $timeout, winresCloudService, cancelService) {
        _classCallCheck(this, ScheduleService);

        this.$q = $q;
        this.$timeout = $timeout;
        this.winresCloudService = winresCloudService;
        this.cancelService = cancelService;
        this.cache = [];
    }

    _createClass(ScheduleService, [{
        key: 'getWeekSchedule',
        value: function getWeekSchedule(year, week, intClasses) {
            // return this.getDummyWeekSchedule(year, week);

            // Replace with automatic Accept-Language header in the future
            var language = this.winresCloudService.getLanguage();

            console.log('[ScheduleService] Getting schedule for week ' + week + '/' + year + ' in ' + language + '.');

            var endpoint = 'Winres/x/Schedules/' + year + '/Week/' + week + "?Language=" + language + parseInternetClassifications(intClasses);

            return this.winresCloudService.get(endpoint).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'getTickets',
        value: function getTickets(destCode) {
            // Replace with automatic Accept-Language header in the future
            var language = this.winresCloudService.getLanguage();

            console.log('[ScheduleService] Getting tickets for', destCode, 'in', language);

            var endpoint = 'Winres/x/Tickets/' + destCode + '?Language=' + language;
            return this.winresCloudService.get(endpoint).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'getTicketInfo',
        value: function getTicketInfo(destinationCode, productCode) {
            var language = this.winresCloudService.getLanguage();

            var endpoint = 'Winres/x/Tickets/?Destination=' + destinationCode + '&Product=' + productCode + '&Language=' + language;
            return this.winresCloudService.get(endpoint).then(function (result) {
                return result.data;
            });
        }
    }, {
        key: 'addToCache',
        value: function addToCache(destinationCode, productCode, beginDate, language, data) {
            this.cache.push({
                destinationCode: destinationCode,
                productCode: productCode,
                beginDate: beginDate,
                language: language,
                data: data
            });
        }
    }, {
        key: 'getFromCache',
        value: function getFromCache(destinationCode, productCode, beginDate, language) {
            var pick = _.filter(this.cache, function (cache) {
                return cache.destinationCode === destinationCode && cache.productCode === productCode && cache.beginDate === beginDate && cache.language === language;
            });
            if (pick && pick.length > 0) return pick[0].data;
            return null;
        }
    }, {
        key: 'getWeekScheduleItemInfo',
        value: function getWeekScheduleItemInfo(destinationCode, productCode, beginDate) {
            var _this = this;

            var language = this.winresCloudService.getLanguage();

            var result = this.getFromCache(destinationCode, productCode, beginDate, language);
            if (result) return this.$q.resolve(result);

            var endpoint = 'Winres/x/Destinations/' + destinationCode + '/Products/' + productCode + '/BriefInfo?BeginDate=' + beginDate + '&Language=' + language;
            return this.winresCloudService.get(endpoint).then(function (result) {
                _this.addToCache(destinationCode, productCode, beginDate, language, result.data);
                return result.data;
            });
        }

        // Return a dummy week schedule for testing purposes.
        // A fake delay is included to simulate a slow network.

    }, {
        key: 'getDummyWeekSchedule',
        value: function getDummyWeekSchedule(year, week) {
            var _this2 = this;

            console.log('[ScheduleService] Getting dummy schedule for week ' + week + '/' + year + '.');

            var timeout = this.$timeout(2000);

            timeout.cancel = function () {
                _this2.$timeout.cancel(timeout);
            };
            this.cancelService.register(timeout);

            return timeout.then(function () {
                if (DUMMY[year] && DUMMY[year][week]) {
                    return DUMMY[year][week];
                } else {
                    return _this2.getDummyWeekScheduleError();
                }
            }, function () {
                // Timeout was canceled
                console.log('[ScheduleService] Dummy request was canceled.');
                return null;
            });
        }
    }, {
        key: 'getDummyWeekScheduleError',
        value: function getDummyWeekScheduleError() {
            return this.$q.reject(DUMMY['error']);
        }

        // Cancel a pending request

    }, {
        key: 'cancel',
        value: function cancel(promise) {
            this.cancelService.cancel(promise);
        }

        // Utilities

        // Return a promise resolving to the logged-in user's customer number.
        // If there is no logged-in user, wait until there is.

    }, {
        key: 'getCustomerNumber',
        value: function getCustomerNumber() {
            return this.customerService.getUserCustomerNumberWhenAvailable();
        }
    }, {
        key: 'connectionNameIfLoggedIn',
        value: function connectionNameIfLoggedIn() {
            return this.customerService.getConnectionNameIfLoggedIn();
        }
    }]);

    return ScheduleService;
}();

ScheduleService.$inject = ['$q', '$timeout', 'winresCloudService', 'cancelService'];

function parseInternetClassifications(intClasses) {
    var intClassesStr = '';

    var i = 0;
    for (i = 0; i < 5; i++) {
        if (intClasses[i] && intClasses[i].length !== 0) {
            intClassesStr += '&IntClass' + (i + 1) + '=' + intClasses[i];
        }
    }

    return intClassesStr;
}


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/scheduleService.js
// module id = 571
// module chunks = 2